import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetWebLoginConfigRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetWebLoginConfigResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getWebLoginConfig = (request: GetWebLoginConfigRequest, options?: CashRequestOptions) =>
  post<GetWebLoginConfigRequest, GetWebLoginConfigResponse>('/2.0/cash/get-web-login-config', request, {
    ...options,
    rejectOnError: true,
  })
